// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { ComponentSpine } from "../../framework/components/ComponentSpine";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { angrybirds_regular_text } from "../AssetDefinitions/FontDefinitions";
import { yt_splash_1366x768_alternative_2 } from "../AssetDefinitions/ImageDefinitions";
import { s_time_loader } from "../AssetDefinitions/SpineDefinitions";
tgfSettings.dialogDefaults.angryLobbyLoader = {
    data: null,
    loaded: false,
    defaultTime: 1000,
    onLoadCallback: null,
    components: [] // The additional components to add
};
export var AngryLobbyLoader = function (properties) {
    "use strict";
    this.name = "AngryLobbyLoader"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.angryLobbyLoader);
    // add base settings
    if (tgfSettings.lobbyScreenDialogProperties) {
        this.setProperties(tgfSettings.lobbyScreenDialogProperties);
    }
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base dialog
tgfDialogs.inherit(AngryLobbyLoader, DialogBase);
AngryLobbyLoader.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    var i;
    this.bgImage = new ComponentPicture({
        image: yt_splash_1366x768_alternative_2,
    });
    this.addComponent(this.bgImage);
    // this.transparentBlack = new ComponentPicture({
    //     x: -100 + tgfGraphics.areaWidth / 2,
    //     y: -100 + tgfGraphics.areaHeight / 2,
    //     xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
    //     yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
    //     alpha: 0.7,
    //     image: s_black_square
    // });
    //
    // this.addComponent(this.transparentBlack);
    this.loadingText = new ComponentLabel({
        text: tgfDictionary.getText("LOADING_TEXT"),
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 + 95,
        font: {
            fontFace: angrybirds_regular_text.fontFace,
            fontSize: 50,
            fillColor: "#FEFEFE",
            align: "center",
            textStyle: "italic",
            fontWeight: "bold",
            baseline: "middle"
        }
    });
    this.addComponent(this.loadingText);
    // this.loaderImage = new ComponentPicture({
    //     x: tgfGraphics.areaWidth / 2,
    //     y: tgfGraphics.areaHeight / 2,
    //     image: s_red_loader
    // });
    this.loaderImage = new ComponentSpine({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        spineAnimation: s_time_loader,
        animationClip: "loading_hourglass",
        repeat: true
    });
    this.addComponent(this.loaderImage);
    // Add the additional components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
};
AngryLobbyLoader.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    AngryLobbyLoader.uber.handleBeginStep.call(this, timePassed);
    //this.loaderImage.setAngle(this.loaderImage.angle + 0.08);
    this.defaultTime -= timePassed;
    if (this.loaded && this.defaultTime < 0) {
        this.onLoad();
        this.loaded = false;
    }
};
AngryLobbyLoader.prototype.isLoaded = function () {
    "use strict";
    this.loaded = true;
};
AngryLobbyLoader.prototype.onLoad = function () {
    "use strict";
    if (this.onLoadCallback) {
        this.hide();
        this.free();
        this.onLoadCallback(this.data);
    }
};
